import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { WEB_APP_ORIGIN } from '../storeConfig';
import DeepLinkShell from '../DeepLinkShell';
import SmartAppCta from '../SmartAppCta';

/** User loyalty referral (/referral/:code) — distinct from affiliate /ref */
const ReferralLanderPage: React.FC = () => {
  const { code } = useParams<{ code: string }>();

  useEffect(() => {
    if (!code) return;
    try {
      sessionStorage.setItem('loyaltyReferralCode', code.toUpperCase());
    } catch {
      /* ignore */
    }
  }, [code]);

  return (
    <DeepLinkShell>
      <div className="dl-card">
        <h1 className="dl-name">You’re invited to LookBel</h1>
        <p className="dl-meta">Sign up with this referral code for loyalty rewards:</p>
        <p className="dl-code">{code || '—'}</p>
        <SmartAppCta
          title="Join in the app"
          subtitle="Download LookBel and enter the code when you register."
          webHref={`${WEB_APP_ORIGIN}/register?referral=${encodeURIComponent(code || '')}`}
          webLabel="Sign up on the web"
        />
      </div>
    </DeepLinkShell>
  );
};

export default ReferralLanderPage;
